import React, { useState, useEffect } from 'react';
import '../styles/RescheduleModal.css';

const RescheduleModal = ({ isOpen, onClose, testDrive, onSubmit }) => {
  const [formData, setFormData] = useState({
    preferred_date: '',
    preferred_time: '',
    location: '',
    mode: 'home'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (testDrive) {
      setFormData({
        preferred_date: testDrive.preferred_date || '',
        preferred_time: testDrive.preferred_time || '',
        location: testDrive.location || '',
        mode: testDrive.mode || 'home'
      });
    }
  }, [testDrive]);

  const handleSubmit = async () => {
    setError('');
    
    // Validation
    if (!formData.preferred_date || !formData.preferred_time || !formData.location) {
      setError('Please fill all required fields');
      return;
    }
    
    setLoading(true);

    try {
      await onSubmit(formData);
      onClose();
    } catch (err) {
      setError(err.response?.data?.errors?.join(', ') || 'Failed to reschedule test drive. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Get minimum date (tomorrow)
  const getMinDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split('T')[0];
  };

  if (!isOpen || !testDrive) return null;

  return (
    <div className="reschedule-overlay" onClick={onClose}>
      <div className="reschedule-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Reschedule Test Drive</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="car-info-section">
          <h3 className="car-name">{testDrive.car.title}</h3>
          <p className="car-details">{testDrive.car.brand} {testDrive.car.model}</p>
        </div>

        <div className="form-container">
          {error && (
            <div className="error-box">
              <span>⚠️</span> {error}
            </div>
          )}

          <div className="form-group">
            <label className="form-label">
              <span className="label-icon">📅</span>
              Preferred Date *
            </label>
            <input
              type="date"
              name="preferred_date"
              value={formData.preferred_date}
              onChange={handleChange}
              min={getMinDate()}
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              <span className="label-icon">🕐</span>
              Preferred Time *
            </label>
            <select
              name="preferred_time"
              value={formData.preferred_time}
              onChange={handleChange}
              className="form-input"
            >
              <option value="">Select time</option>
              <option value="09:00">09:00 AM</option>
              <option value="10:00">10:00 AM</option>
              <option value="11:00">11:00 AM</option>
              <option value="12:00">12:00 PM</option>
              <option value="14:00">02:00 PM</option>
              <option value="15:00">03:00 PM</option>
              <option value="16:00">04:00 PM</option>
              <option value="17:00">05:00 PM</option>
              <option value="18:00">06:00 PM</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">
              <span className="label-icon">📍</span>
              Test Drive Mode *
            </label>
            <div className="mode-selector">
              <button
                type="button"
                className={`mode-button ${formData.mode === 'home' ? 'active' : ''}`}
                onClick={() => setFormData(prev => ({ ...prev, mode: 'home' }))}
              >
                <span className="mode-icon">🏠</span>
                <div className="mode-text">
                  <strong>Home Visit</strong>
                  <small>We'll come to you</small>
                </div>
              </button>
              <button
                type="button"
                className={`mode-button ${formData.mode === 'hub' ? 'active' : ''}`}
                onClick={() => setFormData(prev => ({ ...prev, mode: 'hub' }))}
              >
                <span className="mode-icon">🏢</span>
                <div className="mode-text">
                  <strong>Visit Hub</strong>
                  <small>Test drive at our showroom</small>
                </div>
              </button>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">
              <span className="label-icon">📌</span>
              {formData.mode === 'home' ? 'Your Address *' : 'Nearest Hub Location'}
            </label>
            <textarea
              name="location"
              value={formData.location}
              onChange={handleChange}
              placeholder={formData.mode === 'home' 
                ? 'Enter your complete address...' 
                : 'Select hub or enter preferred location...'}
              rows={3}
              className="form-input form-textarea"
            />
          </div>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className={`submit-button ${loading ? 'disabled' : ''}`}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Updating...
              </>
            ) : (
              <>
                <span>📅</span>
                Confirm Reschedule
              </>
            )}
          </button>
        </div>

        <div className="info-box">
          <span className="info-icon">ℹ️</span>
          <p className="info-text">
            You'll receive an updated confirmation via email and SMS.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RescheduleModal;